(() => {
  const initUmbroBranding = () => {
      var dataNode = document.getElementById("bpProjectData");
      var projects = [];
      try { projects = JSON.parse(dataNode ? dataNode.textContent : "[]"); } catch (error) { projects = []; }
      if (!projects.length) return;
    
      var page = document.getElementById("bpPage");
      if (!page || page.dataset.ready === "true") return;
      page.dataset.ready = "true";
      var projectTabs = document.querySelectorAll(".bp-project-tab");
      var heroImage = document.getElementById("bpHeroImage");
      var artworkSection = document.getElementById("bpArtwork");
      var socialSection = document.getElementById("bpSocial");
      var tripleVinyl = document.getElementById("bpTripleVinyl");
    
      var artworkCard = document.getElementById("bpArtworkCard");
      var artworkFrontImage = document.getElementById("bpArtworkFrontImage");
      var artworkBackImage = document.getElementById("bpArtworkBackImage");
      var artworkFlipBtn = document.getElementById("bpArtworkFlipBtn");
      var artworkTitle = document.getElementById("bpArtworkTitle");
      var artworkText = document.getElementById("bpArtworkText");
    
      var clothingTitle = document.getElementById("bpClothingTitle");
      var clothingText = document.getElementById("bpClothingText");
      var shirtImage = document.getElementById("bpShirtImage");
    
      var socialTitle = document.getElementById("bpSocialTitle");
      var socialText = document.getElementById("bpSocialText");
      var igUsername = document.getElementById("bpIgUsername");
      var igLocation = document.getElementById("bpIgLocation");
      var igPostImage = document.getElementById("bpIgPostImageFile");
      var igLikes = document.getElementById("bpIgLikes");
      var igCaptionName = document.getElementById("bpIgCaptionName");
      var igCaptionText = document.getElementById("bpIgCaptionText");
      var igDate = document.getElementById("bpIgDate");
    
      var mobileProjectName = document.getElementById("bpMobileProjectName");
      var mobileDots = document.querySelectorAll(".bp-mobile-switcher__dot");
      var mobilePrev = document.querySelector("[data-bp-mobile-prev]");
      var mobileNext = document.querySelector("[data-bp-mobile-next]");
    
      var activeProject = 0;
      var artworkIsBack = false;
      var touchStartX = 0;
      var touchStartY = 0;
      var artworkMediaReady = false;
      var socialMediaReady = false;
    
      function hexToRgb(hex) {
        var cleanHex = hex.replace("#", "").trim();
    
        if (cleanHex.length === 3) {
          cleanHex = cleanHex.split("").map(function (char) {
            return char + char;
          }).join("");
        }
    
        var bigint = parseInt(cleanHex, 16);
    
        if (isNaN(bigint)) {
          return "219,173,211";
        }
    
        var r = (bigint >> 16) & 255;
        var g = (bigint >> 8) & 255;
        var b = bigint & 255;
    
        return r + "," + g + "," + b;
      }
    
      function sizedUrl(url, width) {
        if (!url) return "";
        var cleanUrl = url.replace(/([?&])width=\d+/g, "$1").replace(/[?&]$/, "");
        return cleanUrl + (cleanUrl.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
      }
    
      function responsiveSrcset(url, widths) {
        return widths.map(function (width) {
          return sizedUrl(url, width) + " " + width + "w";
        }).join(", ");
      }
    
      function setResponsiveImage(element, url, widths, sizes, defaultWidth) {
        if (!element || !url) return;
        element.src = sizedUrl(url, defaultWidth || widths[widths.length - 1]);
        element.srcset = responsiveSrcset(url, widths);
        element.sizes = sizes;
        element.decoding = "async";
      }
    
      function renderArtworkMedia(project) {
        if (!project) return;
        setResponsiveImage(artworkFrontImage, project.artworkFront, [480, 750, 960, 1200], "(max-width: 749px) 84vw, 42vw", 960);
        setResponsiveImage(artworkBackImage, project.artworkBack, [480, 750, 960, 1200], "(max-width: 749px) 84vw, 42vw", 960);
        if (artworkFrontImage) artworkFrontImage.alt = project.name + " front cover";
        if (artworkBackImage) artworkBackImage.alt = project.name + " back cover";
      }
    
      function renderSocialMedia(project) {
        if (!project) return;
        setResponsiveImage(igPostImage, project.socialPost, [360, 540, 720, 900], "(max-width: 749px) 88vw, 36vw", 720);
        if (igPostImage) igPostImage.alt = project.name + " social campaign post";
      }
    
      function setHighlightedTitle(element, mainText, highlightText) {
        if (!element) return;
    
        element.textContent = "";
    
        var mainNode = document.createTextNode(mainText + " ");
        var span = document.createElement("span");
    
        span.textContent = highlightText;
    
        element.appendChild(mainNode);
        element.appendChild(span);
      }
    
      function updateProject(index) {
        activeProject = (index + projects.length) % projects.length;
    
        var project = projects[activeProject];
    
        if (!project || !page) return;
    
        page.classList.add("is-switching");
    
        page.style.setProperty("--bp-brand-color", project.color);
        page.style.setProperty("--bp-brand-rgb", hexToRgb(project.color));
    
        if (project.heroImage) {
          setResponsiveImage(heroImage, project.heroImage, [480, 640, 750, 960, 1200, 1500, 1800], "100vw", 1200);
        }
    
        if (tripleVinyl) {
          if (activeProject === 0 && project.vinyl) {
            setResponsiveImage(tripleVinyl, project.vinyl, [400, 700, 1000], "(max-width: 749px) 55vw, 30vw", 700);
            tripleVinyl.style.display = "block";
          } else {
            tripleVinyl.style.display = "none";
          }
        }
    
        setHighlightedTitle(artworkTitle, project.artworkTitleMain, project.artworkTitleHighlight);
        if (artworkText) artworkText.textContent = project.artworkText;
        if (artworkMediaReady) renderArtworkMedia(project);
    
        setHighlightedTitle(clothingTitle, project.clothingTitleMain, project.clothingTitleHighlight);
        if (clothingText) clothingText.textContent = project.clothingText;
    
        if (shirtImage) {
          setResponsiveImage(shirtImage, project.shirt, [480, 750, 1100], "(max-width: 749px) 86vw, 46vw", 750);
          shirtImage.alt = project.name + " merchandise design";
        }
    
        setHighlightedTitle(socialTitle, project.socialTitleMain, project.socialTitleHighlight);
        if (socialText) socialText.textContent = project.socialText;
    
        if (igUsername) igUsername.textContent = project.handle;
        if (igLocation) igLocation.textContent = project.location;
        if (igLikes) igLikes.textContent = project.socialLikes;
        if (igCaptionName) igCaptionName.textContent = project.handle;
        if (igCaptionText) igCaptionText.textContent = project.socialCaption;
        if (igDate) igDate.textContent = project.socialDate;
    
        if (socialMediaReady) renderSocialMedia(project);
    
        projectTabs.forEach(function (tab) {
          var tabIndex = Number(tab.getAttribute("data-bp-project"));
          tab.classList.toggle("is-active", tabIndex === activeProject);
    
          if (projects[tabIndex]) {
            tab.textContent = projects[tabIndex].shortName;
          }
        });
    
        if (mobileProjectName) {
          mobileProjectName.textContent = project.shortName;
        }
    
        mobileDots.forEach(function (dot, dotIndex) {
          dot.classList.toggle("is-active", dotIndex === activeProject);
        });
    
        artworkIsBack = false;
    
        if (artworkCard) artworkCard.classList.remove("is-back");
        if (artworkFlipBtn) artworkFlipBtn.textContent = page.dataset.flipFrontLabel || "Reveal back cover";
    
        window.setTimeout(function () {
          page.classList.remove("is-switching");
        }, 120);
      }
    
      projectTabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          updateProject(Number(tab.getAttribute("data-bp-project")));
        });
      });
    
      if (mobilePrev) {
        mobilePrev.addEventListener("click", function () {
          updateProject(activeProject - 1);
        });
      }
    
      if (mobileNext) {
        mobileNext.addEventListener("click", function () {
          updateProject(activeProject + 1);
        });
      }
    
      if (artworkFlipBtn && artworkCard) {
        artworkFlipBtn.addEventListener("click", function () {
          artworkIsBack = !artworkIsBack;
          artworkCard.classList.toggle("is-back", artworkIsBack);
          artworkFlipBtn.textContent = artworkIsBack ? (page.dataset.flipBackLabel || "Show front cover") : (page.dataset.flipFrontLabel || "Reveal back cover");
        });
      }
    
      document.querySelectorAll("[data-scroll-to]").forEach(function (button) {
        button.addEventListener("click", function () {
          var target = document.getElementById(button.getAttribute("data-scroll-to"));
    
          if (!target) return;
    
          target.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        });
      });
    
      if (artworkSection && "IntersectionObserver" in window) {
        var artworkObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            artworkMediaReady = true;
            artworkSection.classList.add("is-visible");
            renderArtworkMedia(projects[activeProject]);
            observer.disconnect();
          });
        }, {
          threshold: .05,
          rootMargin: "100px 0px"
        });
    
        artworkObserver.observe(artworkSection);
      } else if (artworkSection) {
        artworkMediaReady = true;
        artworkSection.classList.add("is-visible");
        renderArtworkMedia(projects[activeProject]);
      }
    
      if (socialSection && "IntersectionObserver" in window) {
        var socialObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            socialMediaReady = true;
            renderSocialMedia(projects[activeProject]);
            observer.disconnect();
          });
        }, {
          threshold: .05,
          rootMargin: "100px 0px"
        });
    
        socialObserver.observe(socialSection);
      } else if (socialSection) {
        socialMediaReady = true;
        renderSocialMedia(projects[activeProject]);
      }
    
      if (page) {
        page.addEventListener("touchstart", function (event) {
          if (window.innerWidth > 700) return;
          if (!event.touches || !event.touches.length) return;
    
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });
    
        page.addEventListener("touchend", function (event) {
          if (window.innerWidth > 700) return;
          if (!event.changedTouches || !event.changedTouches.length) return;
    
          var target = event.target;
    
          if (target && target.closest && target.closest("button, a, input, select, textarea")) {
            return;
          }
    
          var touchEndX = event.changedTouches[0].clientX;
          var touchEndY = event.changedTouches[0].clientY;
    
          var deltaX = touchStartX - touchEndX;
          var deltaY = touchStartY - touchEndY;
    
          if (window.innerWidth <= 700 && Math.abs(deltaX) > 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
            if (deltaX > 0) {
              updateProject(activeProject + 1);
            } else {
              updateProject(activeProject - 1);
            }
          }
        }, { passive: true });
      }
    
    
      if (page) {
        page.classList.add("bp-js");
    
        var reduceMotion = window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    
        var revealItems = page.querySelectorAll(".bp-section .bp-inner");
    
        if (reduceMotion || !("IntersectionObserver" in window)) {
          revealItems.forEach(function (item) {
            item.classList.add("bp-visible");
          });
        } else {
          var revealObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add("bp-visible");
              observer.unobserve(entry.target);
            });
          }, {
            threshold: .12,
            rootMargin: "0px 0px -7% 0px"
          });
    
          revealItems.forEach(function (item) {
            revealObserver.observe(item);
          });
        }
      }
    
      updateProject(0);
  };

  initUmbroBranding();
  document.addEventListener('shopify:section:load', initUmbroBranding);
})();
